module.exports = __webpack_public_path__ + "img/leftbicep-mesomorph-female.7d4a411a.svg";